import { render, staticRenderFns } from "./MembershipForm.vue?vue&type=template&id=0cf5c3d7&scoped=true&"
import script from "./MembershipForm.vue?vue&type=script&lang=ts&"
export * from "./MembershipForm.vue?vue&type=script&lang=ts&"
import style0 from "./MembershipForm.vue?vue&type=style&index=0&id=0cf5c3d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf5c3d7",
  null
  
)

export default component.exports